export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10604.57e77270.jpg";